<template>
  <a-form ref="form" layout="vertical" :model="formState" :rules="rules">
    <a-form-item label="Nombre de la empresa" name="name">
      <a-input v-model:value="formState.name" placeholder="Escribir nombre de la empresa" />
    </a-form-item>

    <div class="columns">
      <a-form-item label="Industria" name="type_industry">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          v-model:value="formState.type_industry"
          placeholder="Seleccionar industria"
        >
          <a-select-option v-for="industry of industries" :key="industry.id">
            {{ industry.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item name="country">
        <template #label>
          <span class="required">*</span>
          <span class="label"> País de la empresa</span>
        </template>
        <selector-country-business
          :code="formState.country"
          :disabled="true"
          @onSelected="formState.country = $event"
        />
      </a-form-item>
    </div>

    <div class="columns">
      <a-form-item label="Número de colaboradores" name="type_size">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          v-model:value="formState.type_size"
          placeholder="Seleccionar número"
        >
          <a-select-option :key="1">1-10</a-select-option>
          <a-select-option :key="2">11-20</a-select-option>
          <a-select-option :key="3">21-50</a-select-option>
          <a-select-option :key="4">51-100</a-select-option>
          <a-select-option :key="5">100-200</a-select-option>
          <a-select-option :key="6">200 a más</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item name="timezone">
        <template #label>
          <span class="required">*</span>
          <span class="label"> Zona horaria de la empresa</span>
        </template>
        <selector-time-zone :code="formState.timezone" @onSelected="formState.timezone = $event" />
      </a-form-item>
    </div>

    <div class="info">
      <InfoCircleOutlined class="info__icon" />

      <p class="info__text">
        Recuerda que la <strong>zona horaria</strong> es irreversible. Por favor, selecciónala con
        precaución, ya que se utilizará en tu plataforma.
      </p>
    </div>

    <!-- <a-col :span="12">
        <a-form-item label="Tipo de negocio" name="type_business">
          <a-select
:getPopupContainer="triggerNode => triggerNode.parentNode"            v-model:value="formState.type_business"
            placeholder="Seleccionar tipo de negocio"
          >
            <a-select-option :key="1">
              <a-popover title="Contact Center & BPO" placement="rightTop">
                <template #content>
                  <p class="container__text">Empresas que manejan múltiples</p>
                  <p class="container__text">campañas entrantes o saliente</p>
                  <p class="container__text">de diferentes clientes,</p>
                  <p class="container__text">como telecomunicaciones, bancos,</p>
                  <p class="container__text">seguros, etc.</p>
                  <div class="footer__content">
                    <p class="container__text">Para conocer mejor sobre cada tipo</p>
                    <p class="container__text">de negocio, ingresa <a>aquí</a></p>
                  </div>
                </template>
                <div style="width: 100%">Contact Center & BPO</div>
              </a-popover>
            </a-select-option>
            <a-select-option :key="2">
              <a-popover title="In-House" placement="rightTop">
                <template #content>
                  <p class="container__text">Empresas con operaciones</p>
                  <p class="container__text">internas de atención al cliente,</p>
                  <p class="container__text">ventas o cobranzas. Pueden</p>
                  <p class="container__text">manejar diferentes campañas,</p>
                  <p class="container__text">pero los clientes son propios de</p>
                  <p class="container__text">la organización.</p>
                  <div class="footer__content">
                    <p class="container__text">Para conocer mejor sobre cada tipo</p>
                    <p class="container__text">de negocio, ingresa <a>aquí</a></p>
                  </div>
                </template>
                <div style="width: 100%">In-House</div>
              </a-popover>
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col> -->

    <div class="columns columns__buttons">
      <a-button class="button" @click="handleBackWindowns"> Volver </a-button>

      <a-button
        class="button"
        type="primary"
        html-type="submit"
        id="business-form-continue-btn"
        @click="handleSubmit"
        :disabled="isDisabled"
      >
        Continuar
      </a-button>
    </div>
  </a-form>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, computed, watch } from "vue";
import { useStore } from "vuex";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import SelectorCountryBusiness from "@/app/shared/components/selectors/SelectorCountryBusiness.vue";
import SelectorTimeZone from "@/app/shared/components/selectors/SelectorTimeZone.vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
    SelectorCountryBusiness,
    SelectorTimeZone,
  },
  setup() {
    const form = ref();
    const visible = ref(false);
    const store = useStore();
    const getInformation = computed(() => store.getters["getInformationWorkspace"]);
    const formState = reactive({
      name: getInformation.value?.name,
      type_industry: getInformation.value?.type_industry,
      type_business: 1, // BPO
      type_size: getInformation.value?.type_size,
      country: getInformation.value?.country,
      timezone: getInformation.value?.timezone,
    });
    watch(
      () => getInformation.value?.country,
      (country) => {
        if (country !== undefined && country !== null) {
          formState.country = country;
        }
      }
    );
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      type_industry: [{ required: true, message: "Campo requerido" }],
      // type_business: [{ required: true, message: "Campo requerido" }],
      type_size: [{ required: true, message: "Campo requerido" }],
      country: [{ required: false, message: "Campo requerido" }],
      timezone: [{ required: false, message: "Campo requerido" }],
    };
    return {
      form,
      rules,
      formState,
      visible,
      getInformation,
    };
  },
  computed: {
    industries() {
      return this.$store.getters["getAllIndustries"];
    },
    countries() {
      return this.$store.getters["getAllCountries"];
    },
    operations() {
      return this.$store.getters["getAllTypesOperation"];
    },
    isDisabled() {
      return (
        this.formState.name == "" ||
        this.formState.type_industry == undefined ||
        this.formState.type_business == undefined ||
        this.formState.type_size == undefined ||
        this.formState.country == undefined ||
        this.formState.timezone == undefined
      );
    },
  },
  methods: {
    handleSubmit() {
      this.form
        .validateFields()
        .then(() => {
          this.saveBusinessInStore(toRaw(this.formState));
          this.$store.dispatch("setRegisterWorkspaceStep", 4);
        })
        .catch(() => {
          return;
        });
    },
    saveBusinessInStore(data) {
      this.$store.dispatch("addPropertiesToCustomer", data);
    },
    handleBackWindowns() {
      this.$store.dispatch("setRegisterWorkspaceStep", 2);
    },
  },
});
</script>
<style lang="sass" scoped>
.container__buttom
  margin-right: 27px

.button
  width: 100%

.text
  display: flex
  font-family: SF Pro Display
  font-style: italic
  font-weight: normal
  font-size: 14px
  line-height: 20px
  text-align: justify

.columns
  display: grid
  grid-template-columns: 1fr 1fr
  gap: 0 12px

  &__buttons
    grid-template-columns: 120px 1fr

.info
  color: $gray-8
  display: inline-flex
  margin: 12px 0 40px

  &__icon
    margin-top: 4px
    margin-right: 8px

  &__text
    font-style: italic
    font-weight: 300

.container__text
  font-size: 12px
  margin-bottom: 3px

.footer__content
  margin-top: 15px
  font-size: 10px
  margin-bottom: 3px

.required
  color: $red-7
  margin-right: 2px
</style>
